// import React from "react";
// import { Navigate } from "react-router";

// export default function SignInPage(props) {
//   if (props.currentUser?.uid) {
//     return <Navigate to="/seasons" />;
//   }

//   return (
//     <div style={{ padding: "2rem" }}>
//       <h2>Sign-in temporarily disabled</h2>
//       <p>The login functionality is being updated. Please check back later.</p>
//     </div>
//   );
// }
import React, { useState } from "react";
import { Navigate } from "react-router";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

export default function SignInPage(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  if (props.currentUser?.uid) {
    // Land signed-in users on Season Audit, the primary workflow (matches the "/" landing).
    return <Navigate to="/audit" />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    const auth = getAuth();

    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      console.error("Sign in failed:", err);
      alert("Login failed");
    }
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Sign in</h2>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "1rem" }}>
          <label htmlFor="email">Email</label>
          <br />
          <input
            id="email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <label htmlFor="password">Password</label>
          <br />
          <input
            id="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>

        <button type="submit">
          Sign in
        </button>
      </form>
    </div>
  );
}
